import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { AwardIcon, UsersIcon, TrendingUpIcon } from 'lucide-react';
import CountUp from 'react-countup';
export function About() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  const stats = [{
    icon: UsersIcon,
    value: 1500,
    suffix: '+',
    label: 'Students Taught'
  }, {
    icon: AwardIcon,
    value: 90,
    suffix: '%',
    label: 'Success Rate'
  }, {
    icon: TrendingUpIcon,
    value: 4,
    suffix: '',
    label: 'Languages Offered'
  }];
  return <section id="about" className="py-24 bg-white" data-id="element-21">
      <div className="max-w-6xl mx-auto px-6" data-id="element-22">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 50
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-23">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-24">
            Your Journey to <span className="text-green-600" data-id="element-25">Fluency</span>
          </h2>
          <div className="text-xl text-slate-600 max-w-3xl mx-auto space-y-4" data-id="element-26">
            <p data-id="element-27">
              The Language Magnate Academy, formerly Frenchpreneur Language
              Services, was born from a passion for language education,
              launching its inaugural program at the University of Benin on
              November 9, 2019, sponsored by Alliance française Enugu. Since
              then, we've instructed over 1,600 students worldwide. On January
              9, 2025, we rebranded as The Language Magnate Academy. "Magnate"
              signifies a powerful and influential leader, reflecting our view
              of both our clients and ourselves as highly successful individuals
              in language learning and services.
            </p>
            <p data-id="element-28">
              As a registered Limited Liability Company, we are committed to
              providing professional, high-quality language education services
              with accountability and excellence.
            </p>
            <p data-id="element-29">
              Whether you are preparing for immigration, advancing your career,
              or pursuing certification, we provide expert instruction with
              proven results.
            </p>
          </div>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-30">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 30
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="text-center p-8 rounded-2xl bg-gradient-to-br from-green-50 to-orange-50 hover:shadow-xl transition-shadow duration-300" data-id="element-31">
              <stat.icon className="w-12 h-12 text-green-600 mx-auto mb-4" data-id="element-32" />
              <div className="text-4xl font-bold text-slate-900 mb-2" data-id="element-33">
                {inView ? <CountUp start={0} end={stat.value} duration={2.5} suffix={stat.suffix} data-id="element-34" /> : `0${stat.suffix}`}
              </div>
              <div className="text-slate-600" data-id="element-35">{stat.label}</div>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mb-16" data-id="element-36">
          <h3 className="text-3xl font-bold text-slate-900 mb-8 text-center" data-id="element-37">
            Students From Around the{' '}
            <span className="text-green-600" data-id="element-38">World</span>
          </h3>
          <div className="flex flex-wrap justify-center gap-6" data-id="element-39">
            {['France', 'Nigeria', 'Canada', 'UK', 'USA', 'India', 'Kenya', 'Ghana'].map(country => <div key={country} className="bg-gradient-to-br from-green-50 to-orange-50 px-6 py-3 rounded-full text-slate-900 font-semibold shadow-md" data-id="element-40">
                {country}
              </div>)}
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0
      }} animate={inView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="bg-slate-900 text-white rounded-3xl p-12 text-center" data-id="element-41">
          <h3 className="text-3xl font-bold mb-4" data-id="element-42">Our Promise</h3>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto" data-id="element-43">
            Excellence in education, personalized attention, and a commitment to
            your success. Join our community of learners achieving their
            language goals with confidence.
          </p>
        </motion.div>
      </div>
    </section>;
}